module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kh-Ld.19ef3aa7.png";